var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconResolveCommentActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z",
    fill: "#56A012"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93508 11.6852C7.78508 11.6852 7.64258 11.6252 7.53758 11.5202L5.41508 9.3977C5.19758 9.1802 5.19758 8.8202 5.41508 8.6027C5.63258 8.3852 5.99258 8.3852 6.21008 8.6027L7.93508 10.3277L11.7901 6.4727C12.0076 6.2552 12.3676 6.2552 12.5851 6.4727C12.8026 6.6902 12.8026 7.05019 12.5851 7.26769L8.33258 11.5202C8.22758 11.6252 8.08508 11.6852 7.93508 11.6852Z",
    fill: "#56A012"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconResolveCommentActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-resolve-comment-active.f1996d390b7fc1e65edd2a8f400fbb99.svg";